module.exports = __webpack_public_path__ + "img/clock-blue.01ba6b9c.svg";